<style lang="less" scoped></style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">banner管理</div>
      <!-- <div class="page-title-div">电站管理</div> -->
      <ZD-list-querys> </ZD-list-querys>
      <div class="page-action-btns flex">
        <!-- <button class="common-bg-button" @click="listAddFun()">新增开屏</button> -->
        <button
          class="common-bg-button"
          @click="listAddFun()"
          v-if="listData.length < 5"
        >
          新增
        </button>
        <button class="common-bg-button" @click="listEditFun()">编 辑</button>
        <!-- <div class="flex-1"></div>
                <el-input size="small" style="width:320px;margin-right:10px;" class="list-serach-input" v-model="queryInfo.pileTypeName" placeholder="请输入充电桩型号名称" clearable></el-input>
                <button class="common-bg-button" @click="getListData(pagination,true)">搜索</button> -->
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table
          :data="listData"
          :stripe="true"
          class="list_tb"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40" align="center">
          </el-table-column>
          <el-table-column type="index" align="center" width="55">
          </el-table-column>
          <el-table-column
            prop="picPath"
            label="图片"
            min-width="200"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.picPath" class="demo-image__preview">
                <el-image
                  style="width: 100px; height: 100px"
                  @mouseover="handleImgBig(scope.row.picPath)"
                  :src="scope.row.picPath"
                  :preview-src-list="srcList"
                >
                </el-image>
              </div>
              <div v-else></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="bannerUrl"
            label="跳转地址"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdByName"
            label="新增人"
            min-width="170"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdWhen"
            label="新增时间"
            min-width="170"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="affiliationType"
            label="应用app"
            min-width="170"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.affiliationType == '01'
                  ? '桩到家4.0'
                  : scope.row.affiliationType == '02'
                  ? '桩到家家庭版'
                  : scope.row.affiliationType == '03'
                  ? '桩到家4.0与家庭版'
                  : ''
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="bannerStatus"
            label="启用状态"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-if="switchUse == '01' && scope.row.bannerStatus == 'OFF'"
                v-model="switchArr[scope.$index]"
                :disabled="true"
              ></el-switch>
              <el-switch
                v-if="switchUse == '01' && scope.row.bannerStatus == 'ON'"
                v-model="switchArr[scope.$index]"
                @change="handleSwitchChange(scope.row, scope.$index)"
              ></el-switch>
              <el-switch
                v-if="switchUse == '02'"
                v-model="switchArr[scope.$index]"
                @change="handleSwitchChange(scope.row, scope.$index)"
              ></el-switch>
            </template>
          </el-table-column>
          <!--分页区 -->
        </el-table>
        <!-- 分页 -->
        <div class="list-pagination">
          <ZD-pagination
            :pagination="pagination"
            v-on:pageUpdate="getListData"
          ></ZD-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      listData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {
        //页码
        bannerType: '03',
      },
      switchArr: [], //启用状态
      srcList: [], //大图地址
      switchUse: '02', //使用状态
    }
  },
  methods: {
    init() {
      this.getListData(this.pagination, true)
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        this.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize
      _.queryInfo.corpNo = _.$store.state.corpNo
      _.$H.get(_, _.$A.banner.findList, _.queryInfo).then((res) => {
        _.listData = res.data.data.bannerEntityPage.content || []
        _.listData.forEach((item, index) => {
          if (item.bannerStatus == 'ON') {
            _.switchArr.push(true)
          } else {
            _.switchArr.push(false)
          }
        })
        if (res.data.data.openCount >= 5) {
          _.switchUse = '01'
        } else {
          _.switchUse = '02'
        }
        _.pagination.total = res.data.data.bannerEntityPage.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    //启用状态切换
    handleSwitchChange(row, index) {
      let _ = this
      row.file = null
      if (row.bannerStatus == 'ON') {
        row.bannerStatus = 'OFF'
        row.bannerStatusName = '关'
      } else {
        row.bannerStatus = 'ON'
        row.bannerStatusName = '开'
      }
      let formData = new FormData()
      Object.keys(row).forEach((key) => {
        formData.append(key, row[key])
      })
      _.$U.showLoading(_)
      _.$H.put(_, _.$A.banner.statusedit, formData).then((res) => {
        _.getListData(_.pagination)
        _.$U.hideLoading(_)
      })
    },
    //选中表格
    handleSelectionChange(e) {
      this.selections = e
    },
    //点击大图
    handleImgBig(picPath) {
      console.log(picPath)
      this.srcList = []
      this.srcList.push(picPath)
    },
    //页面新增方法
    listAddFun() {
      this.$S.listAddFun(this, pageConfig.tableEditObj)
    },
    // 页面编辑方法
    // listEditFun() {
    //     this.$store.state.bannerObj = this.selections[0];
    //     this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
    // },
    // 页面编辑方法
    listEditFun() {
      this.$store.state.bannerObj = this.selections[0]
      this.$S.tableEditFun(this, this.selections, pageConfig.tableEditObj)
    },
  },
  mounted() {
    this.init()
  },
}
</script>
